import { ReceiptEntity, ReceiptFilter } from '../../models'

export const SET_RECEIPTS = 'SET_RECEIPTS'
export const SET_TOTAL_RECEIPTS = 'SET_TOTAL_RECEIPTS'
export const SET_RECEIPTS_LOADED = 'SET_RECEIPTS_LOADED'
export const SET_RECEIPT_FILTER = 'SET_RECEIPT_FILTER'

export interface ReceiptState {
  receipts: ReceiptEntity[]
  totalReceipts: number
  isReceiptsLoaded: boolean
  receiptFilter: ReceiptFilter
}

interface SetReceiptsAction {
  type: typeof SET_RECEIPTS
  payload: ReceiptEntity[]
}

interface SetTotalReceiptsAction {
  type: typeof SET_TOTAL_RECEIPTS
  payload: number
}

interface SetReceiptsLoadedAction {
  type: typeof SET_RECEIPTS_LOADED
  payload: boolean
}

interface SetReceiptFilterAction {
  type: typeof SET_RECEIPT_FILTER
  payload: ReceiptFilter
}

export type ReceiptAction =
  | SetReceiptsAction
  | SetReceiptsLoadedAction
  | SetReceiptFilterAction
  | SetTotalReceiptsAction
